export default "__VITE_ASSET__91afecd0__"